module.exports = __webpack_public_path__ + "img/tyre-size-img.fcc8dbc6.png";